import React from "react";
import PropTypes from "prop-types";

export default function Thumbnail(props) {
	const {imageUrl, width, height, title} = props;

	const styles = {
		thumbnailWrapper: {
			width: width,
			height: height,
			textAlign: "center"
		}
	};
	return (
		<div style={styles.thumbnailWrapper}>
			<img src={imageUrl} alt={title}/>
		</div>
	);
}

Thumbnail.propTypes = {
	imageUrl: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	title: PropTypes.string
};
